import { useState } from 'react'
import TextField from '@mui/material/TextField'
import { object, func } from 'prop-types'
import { CvsButton } from '@components'
import { t } from '@lingui/core/macro'

export const EditFolder = ({ folder = {}, onClose = () => {}, onSubmit = () => {} }) => {
  const [updatedFolder, setUpdatedFolder] = useState({ ...folder })

  const onUpdate = async () => {
    const result = await onSubmit(updatedFolder)
    onClose()
    return result
  }

  return (
    <div style={{ padding: 12, paddingTop: 24 }}>
      <TextField
        name="folder-name"
        required
        variant="outlined"
        style={{ width: '100%' }}
        label={t`Folder name`}
        value={updatedFolder.name ?? ''}
        onChange={e => {
          setUpdatedFolder({ ...updatedFolder, name: e.target.value })
        }}
      />
      <div style={{ marginTop: 24 }}>
        <TextField
          name="description"
          variant="outlined"
          style={{ width: '100%' }}
          label={t`Description`}
          value={updatedFolder.description ?? ''}
          onChange={e => {
            setUpdatedFolder({ ...updatedFolder, description: e.target.value })
          }}
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <CvsButton
          name="save-folder"
          disabled={
            updatedFolder.name?.length === 0 ||
            (folder.name === updatedFolder.name && folder.description === updatedFolder.description)
          }
          variant="contained"
          color="primary"
          onClick={onUpdate}
          style={{ width: '100%' }}
        >
          {t`Save`}
        </CvsButton>
      </div>
    </div>
  )
}

EditFolder.propTypes = {
  folder: object,
  onClose: func,
  onSubmit: func,
}
